import MainCard from "../../../ui-component/cards/MainCard";
import React from "react";
import Button from "@material-ui/core/Button";
import TelegramIcon from '@material-ui/icons/Telegram';
import Grid from "@material-ui/core/Grid";
import {FormattedMessage} from "react-intl";
import TagGenerator from "../../../utils/TagGenerator";
import OrdersPage from "../orders";

const Image = require.context('./../../../assets/images', true);

const ContactsPage = () => {
  let image = Image(`./call-center.svg`).default;

  return (
    <MainCard style={{textAlign: 'center'}}>

      <TagGenerator page={'contacts'}/>

      <Grid container spacing={2}>
        <Grid item md={6} xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <img src={image} width="250" />
            </Grid>


            <Grid item xs={12}>
              <Button variant="contained" startIcon={<TelegramIcon />} href={process.env.REACT_APP_MESSENGER} target={'_blank'}>
                <FormattedMessage id="write-to-telegram" />
              </Button>
            </Grid>
          </Grid>
        </Grid>

        <Grid item md={6} xs={12}>
          <OrdersPage rowsHorizontal={1}/>
        </Grid>
      </Grid>



    </MainCard>
  )
};

export default ContactsPage
